module.exports = {"id":"202113","name":"Moses Odubajo","rating":"72","photo":"./data/images/photos/4/202113.png","club":{"name":"Hull City","logo":"./data/images/clubs/HullCity.png"},"positions":["DD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MosesOdubajo0.json
// module id = 3083
// module chunks = 0